<script setup lang="ts" generic="ItemType = unknown">
import { VfFormRow } from "@/vf"
import VfFormGroup from "@/vf/components/crud/form/VfFormGroup.vue"
import { inject, ref, type Ref } from "vue"

defineProps<{
    itemType?: ItemType
}>()

const { data, schema, name, removeRow } = inject<{
    data: Ref<Record<string, ItemType[]>>
    schema: Ref
    name: Ref
    removeRow: (index: number) => void
}>("vf-form-collection", {
    data: ref({}),
    schema: ref(null),
    name: ref(null),
    removeRow: () => {},
})
</script>

<template>
    <VfFormGroup v-for="(item, index) in data[name]" :key="index" :name="index.toString()">
        <slot v-bind="{ removeRow: () => removeRow(index), item, index }">
            <VfFormRow :name="index.toString()" :schema="schema"></VfFormRow>
            <button type="button" class="btn btn-danger" @click="removeRow(index)">
                {{ $t("crud:button.delete") }}
            </button>
        </slot>
    </VfFormGroup>
</template>
